export default {"src":"/_next/static/media/logo.94ff4a83.svg","height":24,"width":175,"blurWidth":0,"blurHeight":0};